import { useEffect } from 'react';
import styled from 'styled-components';
import { useScene } from '../../hooks';
import { useCursor, useMouse } from '../../hooks/useEditor';
import { CursorData, MouseData } from '../../types/hooks';

export const Cursor = () => {
  const scene = useScene();
  const [mouse] = useMouse<MouseData>();
  const [cursor, setCursor] = useCursor<CursorData>();

  // Show Cursor when an Element is hovered
  useEffect(() => {
    if (mouse.hoveredElementID) {
      const launcherWindowDiv = document.getElementById('launcherWindow');
      const launcherWindowRect = launcherWindowDiv?.getBoundingClientRect()!;

      const elementDiv = document.getElementById(mouse.hoveredElementID);
      const elementRect = elementDiv?.getBoundingClientRect()!;

      const elementDim = {
        x: +(elementRect?.x - launcherWindowRect?.x).toFixed(2),
        y: +(elementRect?.y - launcherWindowRect?.y).toFixed(2),
        width: +(elementRect?.width).toFixed(2),
        height: +(elementRect?.height).toFixed(2),
      };

      setCursor({
        isVisible: true,
        x: elementDim?.x + scene.offset.x,
        y: elementDim?.y + scene.offset.y,
        width: elementDim?.width,
        height: elementDim?.height,
      });
    } else {
      setCursor({
        isVisible: false,
      });
    }
  }, [mouse.hoveredElementID]);

  return (
    <Container
      $isVisible={cursor.isVisible}
      style={{
        position: 'absolute',
        left: cursor.x,
        top: cursor.y,
        width: cursor.width,
        height: cursor.height,
      }}
    />
  );
};

const Container = styled.div<{ $isVisible?: boolean }>`
  pointer-events: none;
  outline: 1px solid var(--accent-color);

  opacity: 0;
  ${({ $isVisible }) =>
    $isVisible &&
    `
      opacity: 1;
    `}
`;
